import { Field } from 'formik'
interface FilterOptionsProps {
    options: Array<ICheckbox>;
  }
export default function FilterProfile({options}: FilterOptionsProps) {
  return (
    <div className=' w-full'>
    <p className='text-gray-5 mb-4'>فروشنده:</p>
    <div className="grid grid-cols-2 w-full gap-4 ">
      {options.map((item, index) => (
        <label
          key={index}
          className="flex items-center gap-2 text-[16px] font-medium text-gray-5"
        >
          <Field type="checkbox" name="type_profile" value={item.value} />
          {item.name}
        </label>
      ))}
    </div>
    <div className="w-[90%]  flex" />
    <hr className=' my-4' />
  </div>
  )
}
